import {Fragment} from "react";
import {Button} from "react-bootstrap";
import {useAppDispatch} from "../../../app/hooks";
import BulkDeleteUrlsModal from "./bulkDeleteUrlsModal/BulkDeleteUrlsModal";
import {setIsOpened} from "./bulkDeleteUrlsModal/BulkDeleteUrlsModalSlice";
import {RequireTier} from "../../auth/RequireTier";

interface BulkDeleteUrlsProps {
  readonly userId: number;
}

const BulkDeleteUrls = (props: BulkDeleteUrlsProps) => {
  const {userId} = props;
  const dispatch = useAppDispatch();

  const openModal = () => {
    dispatch(setIsOpened(true));
  };

  return (
    <Fragment>
      <BulkDeleteUrlsModal userId={userId} />
      <div className="card">
        <div className="card-header">
          <h4 className="card-header-title">Bulk delete cached URLs</h4>
        </div>
        <div className="card-body">
          <p className="text-muted">
            Upload a CSV of cached_urls rows to delete cached pages for this user in bulk. A dry-run preview shows exactly what will be
            removed before anything is deleted.
          </p>
          <RequireTier requiredTier="admin" policy="disable">
            <Button variant="danger" onClick={openModal}>
              Bulk delete from CSV…
            </Button>
          </RequireTier>
        </div>
      </div>
    </Fragment>
  );
};

export default BulkDeleteUrls;
